document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-autoplay="true"]');

  sections.forEach(section => {
    const track = section.querySelector('[data-carousel-track]');
    if (!track) return;

    let interval = 4000;

    let autoplay = setInterval(() => {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: track.clientWidth * 0.7, behavior: 'smooth' });
      }
    }, interval);

    section.addEventListener('mouseenter', () => clearInterval(autoplay));
    section.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => {
        track.scrollBy({ left: track.clientWidth * 0.7, behavior: 'smooth' });
      }, interval);
    });
  });
});
